<script>
  import SwishBetBuilderMarket from "./swish-betbuilder-market";
  import SwishBetBuilderMarketUs from "./swish-betbuilder-market-us";
  import { LAYOUT_NAME } from "../../../../../models/enums/layout-const";

  export default {
    name: "SwishBetBuilderTab",
    functional: true,
    components: {
      SwishBetBuilderMarket,
      SwishBetBuilderMarketUs,
    },
    props: {
      tab: {
        type: Object,
        required: true,
      },
      fixture: {
        type: Object,
        required: true,
      },
      matchInfo: {
        type: Object,
      },
      match: {
        type: Object,
      },
      getMatchDetailsExpandedMarkets: {
        type: Function,
        default: () => { },
      },
    },
    render(_h, { props }) {
      return [
        ...Object.keys(props.tab).map((marketName, idx) => {
          if (APP_SETTINGS.settings.layout !== LAYOUT_NAME.US) {
            return (
              <SwishBetBuilderMarket
                marketName={marketName}
                key={`${idx}_${marketName}`}
                items={props.tab[marketName]}
                fixture={props.fixture}
                match={props.match}
                matchInfo={props.matchInfo}
              />
            );
          }
          if (APP_SETTINGS.settings.layout === LAYOUT_NAME.US) {
            return (
              <SwishBetBuilderMarketUs
                marketName={marketName}
                key={`${idx}_${marketName}`}
                items={props.tab[marketName]}
                fixture={props.fixture}
                match={props.match}
                matchInfo={props.matchInfo}
                oddsExpanded={props.getMatchDetailsExpandedMarkets()}
              />
            );
          }
        }),
      ];
    },
  };
</script>